import { createConsumer } from '@rails/actioncable';

class Cable {
  constructor(config, auth) {
    this.connectionUrl = config.ws;
    this.auth = auth;
  }

  connect() {
    // connectionUrl may be a same-origin relative path (e.g. /backend-api/cable,
    // proxied by the Vite dev server); resolve it against the page origin so the
    // URL constructor doesn't reject it. Absolute URLs ignore the base.
    const url = new URL(this.connectionUrl, window.location.origin);

    // Public pages (the match page) mount logged out, with no token to send.
    const token = this.auth.token();
    if (!token) return this.connectAnonymously();

    // NOTE(ssaunier): cf https://github.com/websanova/vue-auth/blob/master/src/drivers/auth/devise.js
    const tokens = token.split('|');
    url.searchParams.set('token', tokens[1]);
    url.searchParams.set('client_id', tokens[2]);
    url.searchParams.set('uid', tokens[3]);

    return createConsumer(url.toString());
  }

  connectAnonymously() {
    const url = new URL(this.connectionUrl, window.location.origin);
    url.searchParams.set('anonymous', 'true');
    return createConsumer(url.toString());
  }
}

export default {
  install(app, options) {
    app.config.globalProperties.$cable = new Cable(options.config, options.auth);
  },
};
